export class DetailsRow {
  constructor(public label: string, public value: string) {}
}
